import { useLoaderData, useParams, Link } from 'react-router';
import { fetchPopulation, performSearch } from '../project-tva-bosse-actions';
import AreaInfo from './AreaInfo';
import { useSelector } from 'react-redux';

import styles from './area-info.module.less';
import { useEffect } from 'react';
import { hideIntercomBubble } from '../../../support-and-tracking/intercom-actions';
import { cachedDataResponse } from '../../../utils/cache-utils';

const AreaInfoEmbed = () => {
    const { county, municipality, suburb } = useParams();
    const { data, population } = useLoaderData();
    const baseUrl = useSelector((state) => state.baseURL);

    useEffect(() => {
        hideIntercomBubble();
    }, []);

    const pathSegments = [county, municipality, suburb].filter(Boolean).join('/');
    const path = `/bosser/${pathSegments}`;
    const bosseUrl = `${baseUrl}${path}`;

    return (
        <Link className={styles.embedWrapper} to={bosseUrl} target="_blank">
            <AreaInfo
                numberOfProjects={data.count}
                collectedAmount={data.sum}
                areaName={data.key}
                population={population}
                withLogo
            />
        </Link>
    );
};

export const loader = async ({ params, getState }) => {
    const state = getState();
    const tvaEventId = state.campaigns?.tvaEventId;
    const p3aEventId = state.campaigns?.p3aEventId;
    const baseUrl = state.baseURL;
    const { county, municipality, suburb } = params;
    const searchResult = await performSearch({
        county,
        municipality,
        suburb,
        baseUrl,
        eventIds: [tvaEventId, p3aEventId].filter(Boolean),
    });

    let countyData, municipalityData, suburbData;
    if (county) {
        countyData = searchResult?.counties?.filter((c) => c.key === county)[0];
    }
    if (municipality) {
        municipalityData = searchResult?.municipalities?.filter((m) => m.key === municipality)[0];
    }
    if (suburb) {
        suburbData = searchResult?.suburbs?.filter((s) => s.key === suburb)[0];
    }
    const data = suburbData ?? municipalityData ?? countyData;

    if (!data) {
        throw new Response('Not found', { status: 404 });
    }

    const response = await fetchPopulation({ county, municipality, baseUrl });

    let population;

    if (response?.municipality?.[municipality]) {
        population = response?.municipality?.[municipality];
    } else if (response?.county?.[county]) {
        population = response.county[county];
    }
    return cachedDataResponse({ data, population }, { seconds: 60 });
};

export default AreaInfoEmbed;
